import React, { useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { FaSpinner } from 'react-icons/fa';
import { Button } from 'primereact/button';
import { dominioBackend } from '../../config/database';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/css/bim.css';

export default function ModalAlmoxarifado({ idRequisicao, myToast, setOpenDialogAlmoxarifado }) {
  const profissional = JSON.parse(localStorage.getItem('profissional'));
  const [loading, setLoading] = useState(false);
  const [almoxarifadoDestino, setAlmoxarifadoDestino] = useState(null);

  const onSubmit = e => {
    e.preventDefault();

    setLoading(true);
    const dadosNovaRequisicao = {
      idRequisicao,
      idAlmoxarifado: almoxarifadoDestino.id,
    };

    dominioBackend.post(`/api/duplicarRequisicao`, dadosNovaRequisicao).then(
      res => {
        myToast.current.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'A requisição foi duplicada com sucesso',
          life: '3000',
        });
        dominioBackend.get(`/api/exportarRequisicao/${res.data.idNovaRequisicao}`);
        setOpenDialogAlmoxarifado(false);
        setLoading(false);
      },
      () => {
        myToast.current.show({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível duplicar a requisição',
          life: '3000',
        });
        setLoading(false);
      }
    );
  };

  return (
    <div id="divAlmoxarifadoDestino">
      <form onSubmit={onSubmit}>
        <Autocomplete
          id="almoxarifadoID"
          options={profissional.almoxarifadosProfissional}
          getOptionLabel={option => `${option.nome}`}
          fullWidth
          value={almoxarifadoDestino}
          onChange={(e, value) => {
            setAlmoxarifadoDestino(value);
          }}
          renderInput={params => (
            <TextField {...params} label="Almoxarifado destino" variant="outlined" required />
          )}
        />
        <div className="footer">
          <Button type="submit">
            {loading ? <FaSpinner color="#FFF" className="loading" size={14} /> : <>OK</>}
          </Button>
          <Button type="button" onClick={() => setOpenDialogAlmoxarifado(false)}>
            Cancelar
          </Button>
        </div>
      </form>
    </div>
  );
}
